import { getCustomer } from "@/graphql/schemas/shared/utils/getCustomer"
import { CommerceService } from "@/services/commerce"

import { checkPermissions, validateAccessRightsToCustomer } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { findCustomerTargetAddress } from "../utils/customerAddressInformation"

export const mutationSetDefaultBillingAddress = {
  async setDefaultBillingAddress(_parent, args, context, _info) {
    const { customerId, customerKey, addressId, customerNumber } = args
    const commerceApi = CommerceService.api()

    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.ADDRESSES,
      operation: Operations.UPDATE,
    })

    const customer = await getCustomer({ id: customerId, key: customerKey, number: customerNumber })

    await validateAccessRightsToCustomer({
      user: user,
      customerNumber: customer.customerNumber,
    })

    const targetAddress = findCustomerTargetAddress(customer, addressId)

    if (!targetAddress) return null

    // nothing to do
    if (targetAddress.isDefaultBilling) return targetAddress

    // not a billing address
    if (!targetAddress.isBillingAddress) return targetAddress

    // deleted or closed address should not be default
    if (["X", "S"].includes(targetAddress?.custom?.fields?.status)) {
      return targetAddress
    }

    const payload = {
      version: customer.version,
      actions: [
        {
          action: "setDefaultBillingAddress",
          addressId: targetAddress.id,
        },
      ],
    }

    try {
      const updatedCustomer = (
        await commerceApi
          .customers()
          .withId({ ID: customer.id })
          .post({
            body: JSON.stringify(payload),
          })
          .execute()
      )?.body

      const updatedTargetAddress = findCustomerTargetAddress(updatedCustomer, addressId)

      return updatedTargetAddress
    } catch (e) {
      throw new Error(e)
    }
  },
}
